export const MODAL_SHOW = 'MODAL_SHOW'
export const MODAL_HIDE = 'MODAL_HIDE'
export const MODALS_HIDE = 'MODALS_HIDE'
